import { render, staticRenderFns } from "./addInventoryStorage.vue?vue&type=template&id=68553ae4&scoped=true&"
import script from "./addInventoryStorage.vue?vue&type=script&lang=js&"
export * from "./addInventoryStorage.vue?vue&type=script&lang=js&"
import style0 from "./addInventoryStorage.vue?vue&type=style&index=0&id=68553ae4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68553ae4",
  null
  
)

export default component.exports